// Site Configuration

const SITE_CONFIG = {
  name: 'SSVASS Enterprises',
  title: 'National Gems & Jewellery Exhibition',
  
  // Contact Information - These will be fetched from API
  phone: '9334120877',
  phoneDisplay: '+91 93341 20877',
  officePhone: '0612-2675064',
  email: 'info@ssvassgje.in',
  websiteDisplay: 'www.ssvassgje.in',
  websiteUrl: 'https://www.ssvassgje.in',
  address: '2nd Floor, Gupta Mansion, Baari Path, Bakarganj, Patna - 800004, Bihar, India',
  addressLines: [
    '2nd Floor, Gupta Mansion,',
    'Baari Path, Bakarganj,',
    'Patna - 800004, Bihar, India'
  ],
  workingDays: 'Monday - Saturday',
  workingHours: '10:00 AM to 6:00 PM',
  
  // Social Media Links - These will be fetched from API
  facebook: 'https://www.facebook.com/ssvass',
  twitter: 'https://www.twitter.com/ssvass',
  linkedin: 'https://www.linkedin.com/company/ssvass',
  instagram: 'https://www.instagram.com/ssvass',
  youtube: 'https://www.youtube.com/ssvass',
  
  // Event Information
  eventDate: '30 Aug to 01 Sep 2026',
  eventVenue: 'Gyan Bhawan, Gandhi Maidan, Patna',
  edition: '21st',
};

export default SITE_CONFIG;
